var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriviaGameImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 377,
    viewBox: "0 0 320 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_841_9853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V377H320V0H0Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 5L59 9L60 8L58 5ZM80 5C78.5027 7.46948 77.9665 8.33295 81 9V8L80 5ZM82 5V9H83L82 5ZM86 5V7H88V5H86ZM95 5C96.6777 7.88989 98.0162 8.68335 101 7L104 6L99 5L100 7H99L95 5ZM106 5L105 7H107L106 5ZM109 5V7L111 5H109ZM137 5V6H140L138 9H141H142V5H137ZM146 5L143 7V8L146 9V5ZM148 5L149 8H150L151 5H148ZM151 7L152 10L158 5L151 7ZM162 5L160 9L163 8L164 5H162ZM176 5L174 6H173L183 9L182 5H181C181.684 8.42096 179.488 7.0484 180 5H176ZM186 5L184 8V9L186 5ZM189 10H190L194 9L195 6L194 5L189 10ZM245 5L247 7V5H245ZM266 5V10H267L268 5H266ZM269 5L272 8L273 5H269ZM276 5L281 10V5H280L279 8H278L279 5H276ZM284 5L285 7L282 6V7C284.25 7.28821 285.397 7.19681 284 5ZM24 6L21 11H25L24 6ZM26 6V7H30V6H26ZM33 6L32 9H33H34L33 6Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 6V9H68L67 6Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 6V9L202 8V7L200 6ZM207 6L204 8V9L209 8L207 6ZM213 6V9H214L213 6ZM230 6V9H231L230 6Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 6L251 9H252L253 6H250Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 6L288 9H289H290L289 6Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 7V8H130L126 7Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 8L120 10H122L121 8Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 8V12H170L169 8Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 9L77 12H78V9Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 9V11H200L198 9Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 9V10H215L212 9Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 9L244 12L245 13L246 9Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 9V11L252 9H250Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 9V11H259L257 9Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 9L293 14L296 13L295 15H296L291 9Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 10V12H50L48 10Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 10V11L73 14L77 12V11L71 10Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 10L143 12V10H141Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 10L147 14H148H149L148 10Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 10L178 15H179L180 13V12L177 10Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 10L192 13V14L195 13L193 15V16L196 17H197V11L195 10ZM201 10V14L204 11L201 10Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 11L221 15L226 12L220 11Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 11V12L40 13L37 11Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9998 11V15H65.9998L64.9998 11Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 11L105 12L111 15V14L106 11Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 11L120 16H121V11Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 11L150 13H152L151 11ZM157 11L158 16L161 14L157 11ZM170 11L169 12V13L170 14H171L172 13V12L170 11Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 11L187 14L190 12V11H186Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 11V12L242 13L239 11Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16H13L15 15L16 13L12 16Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 12L115 14H117L116 12Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 12L206 13L207 16L211 12H210L209 14L208 12ZM237 12L236 16L239 12H237Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 12V14L300 12H298Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 13V18L44 17V16L40 13Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 13L51 16H52L50 13Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 13L87 16H88L86 13ZM132 13V15L134 13H132ZM142 13V16H143L142 13ZM156 13L155 15H157L156 13ZM198 13V16H199L200 13H198ZM214 13V15H216V13H214ZM217 13V15L219 13H217Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 13L229 17L233 16L230 13ZM256 13L257 16H258V13H256ZM263 13L262 14L263 17H264L265 14L263 13ZM268 13V16H269L270 13H268Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 13V16H301L298 15V16L302 18L304 13H302Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 14V15H57V14H53ZM60 14L59 17H62L60 14ZM68 14V17H69L70 14H68ZM97 15V16L102 15H97ZM145 14V16L147 14H145ZM174 14V16H176L174 14ZM181 14L179 15V16L181 14Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15L16 19H17L19 16L18 15Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 15L32 19L27 18L28 21L31 19L34 20V15ZM200 15V17H202V15H200ZM274 15L272 16V17L274 15Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 16L287 21L290 20L291 16H289Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 16V17L301 20L296 16Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 16L299 18H301L300 16Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 16L304 19L307 20V24H308L305 16Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 19V20L297 21H298L297 18L295 19Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19V22H15L14 19Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 19L313 21V19H311ZM8 20V22L10 20H8Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 20L24 24H27L26 20ZM296 20L299 22V21L296 20Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 21L19 23H21L20 21Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 22V25H11L10 22Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 23L310 27C312.831 26.6575 313.357 24.7507 311 23Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 26L7 31H8L9 26Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 26L304 29H305V26H303ZM307 26L306 28H308L307 26Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 27L16 30L13 34L18 31V28L15 27Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 27V348H292V27H28Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 29L10 33H11V29Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 29V30H305L302 29Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 30L11 34L15 31L12 30Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 30V31L22 32L19 30Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 33L7 36H8V33Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 33L304 39H305L303 33Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 34L13 36V34H11Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 35L13 39H18V38L16 35H14Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 35L308 37H309L310 35H307Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 53H144L146 39L145 64H144V57H143V66L145 65V75H144V67H143V82H154L153 38C142.053 39.2314 143 42.4319 143 53Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 38V39H152L149 38Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 38L159 40L160 43L162 48L164 53L163 56L166 58L167 61L169 66L171 71L170 74H172L173 77L172 80L185 84L201 45L199 43L196 44L197 42H196L192 43L189 41V42C191.922 48.9376 182.702 62.6443 181 70H180C178.366 63.3381 173.293 43.8254 167.581 40.0278C164.88 38.232 160.153 38.7506 157 38Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 38V39H167L158 38Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 38L313 41L314 39H313L312 41L315 42V38Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 39V64H145L146 39H144Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 40L7 44H8V40H5Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 40L310 44L313 43L309 40Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 43L16 45L15 43L18 44L12 43Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 42L126 44L120 43L121 45L116 44L117 46L114 45L110 46L109 49L104 51C97.556 50.3752 98.0023 55.9586 98 61V94H99V52H100V95L109 92V84C109.001 82.345 108.913 80.6542 109.059 79.0038C110.402 63.7865 123.444 81.6999 128 83.7816C131.641 85.4452 136.325 83.9054 140 83L126 68C135.422 60.5005 142.297 45.133 125 42Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 42L180 70H181L191 42H189ZM192 42V43H195L192 42ZM123 43V44H126L123 43Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 45.0003H316C314.444 43.1874 313.556 43.1874 312 45.0003Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 44V45H121L118 44Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 45C203 58.7997 196.404 88.9586 214 92C214 78.9029 217.724 58.8953 212 47L208 48L209 46L206 45H205V87H204C204 75.0427 207.611 55.9878 203 45Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 45V87H205C205 75.0427 208.611 55.9878 204 45Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 48V52H15H16L14 48Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 49L5 51V52L7 53H8L10 52L8 49Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 51L310 53V51H308Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 52V94H100C100 82.0427 103.611 62.9877 99 52Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 65C116.696 62.9418 124.501 61.0929 125 52C114.992 52.2132 109.008 54.5324 109 65ZM311 52C313.15 54.0749 314.205 54.5599 316 52H311Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 54L121 61V62C124.468 60.3287 127.272 58.0639 126 54Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 54L304 60L308 59L305 54Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 55L9 56V57L11 55Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 57.9996L88 56.9996L87 59.9996L84 61.9996L81 63.9996L77 66.9996L72 70.9996C65.0808 72.1836 62.0728 78.5257 62 84.9996L73 77.9996V111C89.079 107.444 79.2706 84.5034 82.3426 73.0181C83.9391 67.0492 91.0364 66.9916 94.1111 62.4487C96.7285 58.5814 91.6646 53.2353 91 57.9996Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 56V59C312.006 57.8734 312.006 57.1266 310 56Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 56L314 60H315V56Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 58V65V66L7 68L9 58Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 59C227.855 67.8155 217.923 82.7557 218 93L235 60L233 59Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 60C228.04 69.7764 211.934 92.6787 227 99L230 92C245.395 97.8369 244.808 112.488 257 121C255.199 106.256 249.747 91.3247 245.856 77C244.747 72.915 243.612 64.5564 239 64L235 60Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 62L13 65V62H11Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 62V65H308L307 62Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 63V65H315L313 63Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 65V75H145L144 65Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 65L304 69V70L307 69L305 65Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 71L10 73V74L12 76H13L14 71Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 71L304 78H305L308 71H306Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 78H6L8 77C6.58274 74.4766 5.5169 75.5416 5 78Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 77H310L309 75L307 77ZM144 76V79H145L144 76Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 76C233.989 83.405 234.879 86.0168 242 90L237 76ZM310 76L314 79L313 76H310ZM314 76L315 80H316L314 76Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 77V78L312 79V78L308 77Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 79V80H9V79H6Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 80L310 85H311L312 80Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 81L9 83V82L6 81Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 84L312 85L313 88H314L315 84Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 87V93L14 94L16 90H13L11 87Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 88V90H307V88H305Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 91L310 94V93L305 91Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 92L5 96H9V95L6 96L9 92H7Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 94L311 96V94H309Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 95V98H316L315 95Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 97V100H307L306 97Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 100H311L310 98L308 100Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 98L315 101L312 102L316 105L314 103V102L313 98Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 100L13 105H15L16 104L14 99L11 100Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 100V103H310L307 100Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 103V108H306L305 103Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 105L156 108H157L158 105H155Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 105V107H309L307 105Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 106V109H15.9998L16.9998 106H14.9998Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 108V109L182 110V107L179 108Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 107L314 110H315L313 107Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 109V111H102V109H100Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 109V113L308 112V111L306 109H304Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 110L15 112V111L12 110Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 110L100 111V112L102 110Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 111V113H7L5 111Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 111V119H147V111H139Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 111L314 114H315V111Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 112V118C201.911 117.348 202.7 115.864 203 112H198Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 113L310 115H312L311 113Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 114L6 116V117C8.56549 116.449 8.86019 115.86 7 114Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 137.001C149.049 143.323 147 153.789 147 163.001H148V158.001C153.098 162.593 152.982 169.484 153 176.001L182 163.001C186.684 158.868 193.319 158.514 195.991 151.997C197.494 148.33 196.502 145.024 196.236 141.286C195.855 135.933 197.868 131.95 194.347 127.02C180.919 108.21 144.129 112.895 141 137.001Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 114L305 123L302 122V123L305 124C306.664 121.568 308.882 119.471 305 119V118L308 117V116L303 114Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 115L316 118V117L313 115Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 116L115 117V118V119L118 116H116Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 117L116 119V120L118 117Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 120V122H17L15 120Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 121L97 128H98C102.907 124.22 104.969 126.731 110 129C106.73 124.375 102.692 119.583 98 125H97L92 121Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 122L11 125H14L13 122Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.279 123.252C216.838 124.436 218.055 128.093 220.737 127.252C223.644 126.341 222.088 121.888 219.279 123.252Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 123L16 126H17L15 123Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 127.001L309 125.001C306.687 123.884 305.988 124.611 306 127.001Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 125L130 128H131V125Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 125L131 129L134 125H132Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 125V129H135L134 125Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 127V130H313V128H312L313 132L315 133H316L314 127Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 130V132L80 134V128L75 130Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 129L309 131V130L306 129Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 130V137L7 139H8L5 130Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 131L303 135H304L305 133L302 131Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99977 132C7.8484 135.434 8.28563 136.612 10.9998 139L8.99977 132Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 132V135L304 136V138L307 139V138L305 136L307 132Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 161.001L186.076 169.171L185 183.001C189.91 180.81 195.625 177.21 201 176.561C211.385 175.308 222.433 180.078 230.66 170.896C246.554 153.156 217.963 130.618 200.144 134.408C193.936 135.729 197.403 144.908 196.757 149.001C195.672 155.879 188.415 160.302 182 161.001Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 134V135H206L203 134Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 134L238 142L242 139V138L240 137V136L242 134H240Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 135V139H14L13 135Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 135V137H310L308 135Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 183C141.671 169.776 153.005 155.034 145.543 141.044C141.762 133.954 131.706 136 125 136C115.461 136 100.937 133.271 92.0045 136.742C82.6589 140.375 81.935 162.231 88.2784 168.772C95.7865 176.513 114.223 170.631 124 172.148C130.149 173.102 135.028 179.6 140 183ZM311 139H312L313 137L311 139Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 137V139L314 137H312Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 141V142L312 144L308 141Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 142V144H14V142H12Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 147.999C119.454 146.389 116.829 146.788 114 156.999C129.614 151.978 115.614 134.957 108 147.999Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 147L10 151H11L13 149L11 147Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 147L75 152H79L76 147Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 147V150H123L122 147Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 147L303 150H304L302 147Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 148V149H112L109 148Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 149V161H204V149H202Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 149V153H207L206 149Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 149V161H210V149H208ZM214 149V161H216V149H214Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 150V155C316.504 154.249 315.659 152.122 316 149L313 150Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 150V154H213L212 150Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 151V153H310L308 151Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 153V157H6L10 156L9 153H5Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 153L307 155H308L309 153H306Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 154L241 156L246 160L245 154Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 155V157L311 155H309Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 157.001L6 162.001H9L6 164.001V165.001L10 163.001V162.001L7 157.001Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 157V158H117L114 157Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 157V162H236L235 157Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 158L313 161V160L311 158H309Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 159V162H16L15 159Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 159V163H117V159H114Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 159V162H211L210 159Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 161V165H306L307 161H305Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 162L201 163V164V165L204 162H202ZM208 162V165H210V162H208ZM214 162V165H216V162H214Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 165V169H13V170L12 171H13L15 164L11 165Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 165L312 166V167L314 165Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 166L307 171H308V166L306 168L303 166Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 167V171H187L186 167Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 173V176H176V173H174Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 173L303 174V175L308 183L306 173Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 173L313 180H316V179V173H314Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 175V176L84 177L83 174L80 175Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 176L83 178V177L80 176Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 176L207 177V178L220 177L219 176Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 177L13 178V179L15 177Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 188.001C130.573 186.101 123.526 187.4 117 185.687C111.529 184.251 108.716 178.508 103 177.345C91.5137 175.009 73.8904 191.012 72.2144 202.001C70.135 215.635 92.2537 236.957 105.985 230.722C112.851 227.605 123.307 216.822 126.346 210.001C127.942 206.422 126.616 202.44 128.117 199.001C129.936 194.831 134.382 191.717 137 188.001Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 178L120 182H123L121 178Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 178V181H240V178H236Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 179V183H141L140 179ZM145 180V181L147 183H148V179L145 180Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 180V182H11L9 180Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 180V183H12L11 180Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 180L145 182H147L146 180Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 180V182L312 180H310Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 182V186H7L8 182H6Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 183V188H77V183H71Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 184V185H162L159 184Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 188.999L146 195.999H145V192.999H144L145 196.999C140.986 200.511 144 213.633 144 218.999H145L151 198.999H152L154 203.999L158 188.999H159L158 205.999H159L164 198.999C163.143 203.916 164.141 206.024 167 209.999L170 208.999L169 201.999H170L172 216.999H173C176.927 209.06 179.685 204.082 178 194.999L175 195.999L176 193.999L173 194.999L174 189.999H173V193.999H172V187.999H171V194.999C166.494 179.946 158.748 186.809 147 188.999Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 185C203.9 194.716 195.033 190.713 186 190L194.838 202.004L192.633 210L196 226C202.436 226.889 205.559 229.605 209 235L224.827 234.187L239 226L242.735 210.83L239 195L225.791 186.697L209 185Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 186L12 191L15 192V186Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 186V190H245L244 186Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 186V190H248V186H245Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 186V190H249L248 186ZM306 188H309L308 186L306 188Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 196H148V190H147L148 197H149L150 190H152L153 197H154L155 190L158 188C151.882 186.822 149.191 190.172 149 196ZM160 195V196C165.165 196.754 167.6 191.478 169 187L160 195ZM170 187V195H171L170 187Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 189L153 196H154L157 189H152ZM162 195V196L168 189L162 195Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 188V194H173L172 188Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 189L156 197C159.828 196.18 159.714 191.974 158 189ZM307 189L305 194V207H306L308 205V204L305 203V197H308L309 191L307 192V189Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 190L7 194H8L5 190Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 191V196H146L145 191Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 192L173 195L176 194L175 196H176L175 192Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 194L10 197H11V193L8 194Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 195L7 199H8L5 195Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 195V196L175 197V196L171 195Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 197L13 201L14 200L11 197ZM15 197V200H16L15 197Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 197V200H157L156 197Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 198L151 207V208L164 207L163 206L162 208H161L162 204L158 207L157 198Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 198V203H159L158 198Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 198L315 201H316L314 198Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 199L163 202H164V199H162Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 200L152 203H153L151 200Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 200V202L312 200H310Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 201V205H29L28 201Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 202V203H103L98 202Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 201L159 206L162 204L161 208H162V201Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 203V204H13L12 210C14.7535 209.473 16.9013 207.837 13 207V206L15 205L13 202L10 203ZM88 202C87.5009 205.314 88.0594 206.38 91 208V207L88 202Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6026 203.157C87.8698 204.314 89.6642 207.001 91.3974 205.843C93.1301 204.686 91.3358 201.999 89.6026 203.157Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6026 203.157C97.8698 204.314 99.6643 207.001 101.397 205.843C103.13 204.686 101.336 201.999 99.6026 203.157Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 202C107.501 205.314 108.059 206.38 111 208V207L108 202Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.603 203.157C107.87 204.314 109.664 207.001 111.397 205.843C113.13 204.686 111.336 201.999 109.603 203.157Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 202V207H170L169 202Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 203V206H153L152 203Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 203V205H155L153 203Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 203V206H158L157 203Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 203L314 207V208L312 210C314.695 207.349 314.791 205.596 312 203Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 205V208H171L170 205Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 207L166 210H167L165 207Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 208V209C154.952 209.301 156.822 210.118 158 214H159L161 212L163 216H164C162.983 212.533 162.767 210.894 166 209L151 208Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 210C163.383 215.009 166.005 216.36 171 215L170 210L166 211L162 210Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 209V213H171L170 209Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 211V213L7 211H5Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 211V218H144L143 211Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 212V215H16L15 212Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 212V214L309 212H307Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 213V217H176L175 213Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 214V217H304L303 214Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 215C161 222.88 155.634 238.66 166 239L168 229L165 230H164V218H165C165.463 223.939 168.922 223.772 174 225V219L170 218L172 216L166 218L165 215H161Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 216V217H156L151 216Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 216.999L7 218.999H9L8 216.999Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 217L13 220H14V217H12Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 217V221H146L145 217Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 217L313 223H314L312 217Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 219L14 224H15V219Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 219L166 223L171 222V221L167 219Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 219L306 221H308L307 219Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 219V222H309L310 219H308Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 221L129 225L130 220L124 221Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 224L15 227V226L12 224Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 224V225L315 227L312 224Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 226L5 227V228V229L8 230H9L7 226Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 226V229L172 228V227L170 226Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 226L307 230H308V226Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 228V229L307 230V229L303 228ZM13 231C15.3962 231.575 15.487 231.475 16 229L13 231Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 233L84 235V231L79 233Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 232L8 237H9L6 232Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 234V237H196V234H193Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 234V236H313L311 234Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 235L302 237V238L306 240L303 239V240L306 242L308 241L305 235ZM307 235V237H309L307 235Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 237L104 239V240L106 241V242L103 246L108 242L106 237Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 239V240C12.6722 240 12.3892 241.148 11 243L14 244L15 240L12 238L10 239Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 239C10.4252 241.396 10.5247 241.487 12.9998 242L10.9998 239Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 243L145 245L138 247L136 246C132.577 253.112 132.292 265.708 143 265C145.879 268.833 150.596 268.955 155 268C157.448 270.802 162.552 270.802 165 268L177 267L176 264L178 266C184.355 263.661 191.879 248.995 182 247L178 246L175 245C170.647 239.25 156.217 235.782 152 243Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 241.172C114.098 242.686 116.895 246.797 119.218 244.919C121.237 243.288 118.815 239.836 116.603 241.172Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 240L312 242V240H310Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 242L7 244H9L8 242Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 242V246H11L10 242Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201 243L203 246H204L205 244H206L208 246L201 243Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 243L303 248L305 249H306L305 245L307 246L305 243Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 244L7 250H8L6 244Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 244L223 248L226 245L222 244Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 244L311 246V247H315L312 244Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 245V248H311L308 245Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 247L13 249V247H11Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 248L13 251L16 249L14 248Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 249L306 253V252L303 249Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 249V250H311L308 249Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 249V250L315 252H316L315 249H312Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 251L9 253H11L10 251Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 252V256H14L13 252Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 253L197 256L200 254L198 253Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 255V260H309L308 255Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0002 256V298H70.0002V257L75.0002 261L69.0002 256Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 257V260H6L5 257Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 257V271H71L70 257Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 270L234 273C226.698 272.936 218.752 278.142 221 286L232 280V314L235 311C246.003 308.968 236.877 281.978 241.028 274.039C244.421 267.55 250.732 266.26 251 258C245.362 259.917 239.693 264.682 237 270Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 258V259L313 261H314L312 258Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 259V289L73 301L72 262L77 265L71 259Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 261L16 264L17 262V261H13Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 261L238 268V269H241L247 261Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9999 262C72.8293 272.509 67.6952 300.994 77.9999 306V282H78.9999L81.9999 287C81.602 289.495 81.3723 291 83.9999 291C83.4233 293.711 83.2324 294.395 85.9999 295V296L83.9999 297L90.9999 309L92.9999 318L93.9999 319L95.9999 318L102 323C102 311.791 105.975 291.528 101.397 281.33C100.168 278.595 96.9742 277.936 94.9999 276H93.9999V302H90.9999L91.9999 299H89.9999C90.6335 296.421 90.8187 295 87.9999 295L88.9999 292H86.9999L87.9999 289L84.9999 287C85.353 283.53 84.9131 278.531 80.9999 278C81.4956 275.277 82.0897 272.464 78.9999 272L77.9999 264L74.9999 265L73.9999 262H71.9999Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 263V265L316 263H314ZM6 264V266H8L6 264Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 264L178 266V264H176Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 264L305 266H307L306 264Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 269L12 272H13L15 271L16 269V268L14 267L17 266L14 269Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 269L6 270L9 278L10 277L9 270L7 269Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 270V271H305L302 270ZM306 269L307 272H308L306 269Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 272V277H71L70 272Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 272L303 273L308 276L305 272Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 273L312 276H313V273H311Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 274V300H93V275L96 276L92 274Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 275L15 280L17 277L14 275Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 275V302H94L95 275H93Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 275V278L230 277V276L228 275ZM238 275V280H239L238 275Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 275L315 278H316V275H314Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 276V277L98 278L95 276Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 276L308 279H309L307 276Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 277L218 284H219L220 277Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 278V283H71L70 278Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 279V281H100L98 279Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 279L311 284H312V279ZM6 280V282H8V280H6Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 280V314H232L231 280Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 281V314H231L230 281Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 282.001L7 287.001H8L9 282.001Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 282L303 286L304 288H305H306L304 282Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 283V287H71L70 283Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 283L110 326H111C111 314.224 107.211 294.409 113 284L109 283Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201 303V304C209.683 300.509 200.808 288.133 211 284C200.537 281.835 205.993 298.111 201 303Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 286L206 285L200 306H193L194 309L189 308L192 309C191.344 305.718 187.345 306.277 187 308H186L187 293H178V335C188.915 334.645 187.384 323.273 186 315L205 311L207 326C214.539 326.605 214 320.997 214 315V283L210 286Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 284V289H11L12 286H13L14 289L11 291L12 292L16 284H15C15 287.193 12.1582 284.795 10 284Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 285C108.982 295.21 110.945 308.369 111.001 319C111.026 323.79 111.183 328.577 117 328L120 330C120 318.288 125.792 288.327 112 285Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 285V302H204L203 285Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 286L11 290L14 289L12 286Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 287V288L119 289V288L114 287Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 289L7 292H8V289Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 289V299H71L70 289Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 289L304 295H305L303 289Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 290V291H186L183 290Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 291L10 298L16 294L14 291Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 291V292H149L138 291ZM176 334H177V292H181C175.329 290.142 176.002 297.184 176 301V334Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 291V292H187V306C189.744 299.46 189.062 291.265 181 291Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 291L308 293H309L310 291H307Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 316.999H127C127 299.023 134.347 292.999 152 292.999C133.988 285.441 124.007 301.23 126 316.999Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 292V293H155L152 292Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 292V334H178C178 323.819 173.824 301.151 180 293L177 292Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 298C128.626 298.885 127.639 302.907 127 307H128L129 305L128 309L130 308V309C126.705 313.529 125.931 320.527 131 324L140 335L143 334C145.51 337.539 155.085 338.405 158 335C171.489 336.956 170 323.056 170 314C166.05 315.317 150.305 315.782 151 313H150V321L160 320L154 331L136 321C136.725 316.717 134.881 311.786 136.778 307.718C142.083 296.34 153.89 300.175 160 308L169 306L167 304C167.405 300.14 160.343 291.892 159 298H158V294L155 295C150.82 290.222 136.024 292.69 133 298Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 293V294H148L144 293Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 295V298L142 297V294L136 295Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 294V296L308 294H306Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 294L313 297L314 295H313L312 297L315 298V294Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 295L158 298H159V295H157ZM179 295V308H180L181 295H179Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 296L7 300H8V296H5Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 296L310 300L313 299L309 296Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 299L16 301L15 297L12 299Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 297V300H292L291 297Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 299L129 303L133 304L131 299ZM146 299V300H149L146 299ZM164 299V301H166L164 299Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 301H316C314.444 299.187 313.556 299.187 312 301Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 300V301H149L146 300Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 302L95 305V304L92 302Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 303V306H126L125 303Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 303V304H201L198 303Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 304V308H15H16L14 304Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 304L89 307H90L88 304ZM115 304V324H116L115 304Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 304V305H200L197 304Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 305L5 307V308L7 309H8L10 308L8 305Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 305L127 315H128L130 308L128 309V305Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 305V308H187L186 305Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 305V306H197L193 305Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 306V307H193L189 306Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 307L189 308C191.046 310.261 192.486 309.36 194 307H192Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 307L310 309V307H308Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 308C313.15 310.075 314.205 310.56 316 308H311Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 309V312H137L136 309Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 309L206 313H207L208 309H205Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 310L304 316L308 315L305 310Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 311L9 312V313L11 311Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 311V327H205L204 311Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 312V319H149L148 312Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 312V313L169 314L149 312Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 312V320H180L179 312Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 312V315C312.006 313.873 312.006 313.127 310 312Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 312L314 316H315V312Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 313V316H126L125 313Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 313V314H168L151 313Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 313V320H182L181 313Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 314V321V322L7 324L9 314Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 314V315H158L150 314ZM159 314V315H163L159 314ZM164 314V315H169L164 314Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 314V317H207L206 314Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 316V334H188L187 316Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 318L13 321V318H11Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 318V321H308L307 318Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 319V323H187L186 319Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 319V321H315L313 319Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 321L158 325H159L157 321Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 321C157.746 326.813 153.032 327.944 148 329V330C152.104 329.812 164.631 326.797 158 321Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 321L304 325V326L307 325L305 321Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 324L160 328L164 324H161ZM179 324V334H180L179 324Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 327L10 329V330L12 332H13L14 327Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 327L304 334H305L308 327H306Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 328V329H151L146 328Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 330V331H154L149 330Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 334H6L8 333C6.58275 330.477 5.5169 331.542 5 334Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 333H310L309 331L307 333Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 332L314 335L313 332H310ZM314 332L315 336H316L314 332Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 333V334L312 335V334L308 333Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 335V336H9V335H6Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 335L19 343V336L16 335Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 335V336L306 338L305 335H302Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 336V337H152L149 336Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 336L307 338H309L308 336Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 337L9 339V338L6 337Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 337V338H154L150 337Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 339V341L303 339H301Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 340L13 342H15L14 340Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 340L312 341L313 344H314L315 340Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 341L301 342C301.734 343.993 302.859 347.001 300 345L299 348C302.618 347.044 304.514 344.696 303 341Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 343L14 350L15 345L11 343Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 346L19 349L24 352V351L22 352L24 350V349L20 346Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 347V348H141L138 347Z",
    fill: "#B4DD35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 348L307 349L311 352L308 348Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 356L295 353L298 350C294.834 351.252 292.247 355.242 297 356Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 351L304 353H306L305 351Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 352V355L20 352H18Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 353L303 355H305L304 353Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 353L307 359L310 358L308 357V356L311 355L306 353Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 354L18 359L19 358L14 354Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 354V355L23 356L20 354ZM289 362H290L289 359L291 360L289 356L293 355C288.304 354.352 287.644 358.367 289 362Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 356L13 361H15L16 360L14 355L11 356Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 355V358H27L26 355ZM29 355V357H31V355H29Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 357V358L296 359V358L291 357Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 358L33 362H34L31 358Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 359.001V361.001H20.0002L18.0002 359.001Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 359V360V361H279V360L274 359Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 359L303 362L306 364L305 359Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 360V363H43L42 360ZM70 360L72 364H73L70 360ZM130 360L128 361L129 364L125 361L127 365L131 364L132 361L130 360ZM169 361L176 364L174 363V362L181 361H169ZM214 360L213 361L215 364H211L212 361H211L210 364H216L214 360ZM218 360L217 366H218V360ZM221 360L220 366H221L223 363L222 366H223L226 365L225 362L221 360Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 360V363H299L298 360Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 361V364H36L37 361H35ZM47 361V364H50V361H47ZM79 361V362H82V361H79ZM84 361L82 363V364L85 363L87 367L84 361ZM92 361L94 364L91 363L90 367L94 366L97 361L95 363H94L92 361ZM101 361L99 365L101 366H102L106 365V364L101 361ZM112 361L110 365L107 364V365V366H112L111 364L114 365L112 361ZM120 361L126 365V364L123 361H120ZM143 361V362L144 364H147L143 361ZM153 362L155 366H156L155 362L158 363L153 362ZM194 361L195 364H197L198 361H194ZM231 361L230 364H231V361ZM234 361V362L235 364L237 366H244L234 361ZM251 361L248 363L249 366H252H254V367L259 364L258 367L261 366L263 363V362L259 361V362H261V363L251 361ZM281 361L279 365H280L281 361Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 362.001L15.9998 366.001L20.9998 364.001V363.001L14.9998 362.001Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 362V365H40L39 362ZM60 362L64 366L65 362H64V365L60 362ZM114 362L117 364V363L114 362ZM134 362L135 367H136L134 362ZM159 362L158 366L163 365L162 362H159ZM187 362L189 366L190 365L187 362ZM205 362L202 366L206 365L205 367L209 366V365L205 362Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 362L274 366V365L272 363L274 364V363L271 362Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 363V365H18L16 363Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 363V365L25 363H23Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 363L58 366H59L57 363Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 363L116 367L120 366L118 363ZM151 363V366H152L151 363Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 363V366H186L185 363Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 363V365H274L272 363Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 363V365L277 363H275Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 365V366L168 365H164Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 364V365H269L264 364Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 365L23 367V365H21ZM25 365L26 367H27L28 365H25Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 365L36 367V365H34ZM44 365L42 366V367L44 365Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 365V367L50 365H48Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 365V366H79L76 365Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 365L117 369H120L118 365Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 365V368H139L138 365Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 365V366L236 367L233 365Z",
    fill: "#3D36AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 365L282 367H283L284 365H281Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 365L289 366V367C291.202 367.519 292.179 367.24 291 365ZM300 365L299 369H300V365ZM33 366L36 368V367L33 366Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 366V367H78L75 366Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 366V368H115L113 366Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 366V367V368L155 367V366H152ZM176 367V368L179 369L180 368L176 367Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 366V367H216L213 366Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 368V369L47 367L43 368Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 367V368H101L98 367Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 367L142 372L145 370L140 367Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 367C154.856 370.03 155.92 370.283 159 370V369L154 367Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 367V368H213L207 367Z",
    fill: "#D35A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 367V369H262L260 367Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 368V370L28 368H26Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 369V370H81L76 369Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 368L90 370H92L91 368ZM104 371H105L107 370C105.188 368.499 104.978 368.842 104 371Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 368L175 369V370L177 368Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 371H219L222 369L218 371Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 369V370L234 368L229 369ZM237 368V369V370L241 369V368H237Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 369V371H39L37 369ZM62 372H67C65.2202 369.626 63.7798 369.626 62 372Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 371H173L171 369L170 371ZM206 369L205 372H208L206 369Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 369C253.033 371.882 254.937 371.784 257 369L255 371L251 369ZM259 369V372H260L259 369Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 370V371L50 372V371L45 370Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 370V372H117L115 370Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 371V372L169 371H165ZM189 370V371L193 372V371V370H189ZM196 370L199 372V371L196 370ZM201 370V372L203 370H201ZM212 370L214 372V370H212Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 370V371L266 372V371V370H263Z",
    fill: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 371V372H274L270 371ZM41 371V372H44L41 371ZM101 371V372H104L101 371ZM236 371V372H239L236 371ZM284 371V372H287L284 371Z",
    fill: "#F8FAF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_9853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 377,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriviaGameImg);
export default __webpack_public_path__ + "static/media/TriviaGameImg.fc40c8ba019514b6e93048ba822ad2d2.svg";
export { ForwardRef as ReactComponent };